module.exports = __webpack_public_path__ + "img/icon_logo.d4ab03d3.png";